import { useEffect } from "react";

export const useGoogleFonts = (fonts: string[]) => {
    const ignoredFonts = [
        "WickedRegular",
        "Arial",
        "Times New Roman",
        "Courier New",
        "Roboto",
        "Verdana",
        "Georgia"
    ];

    useEffect(() => {
        const filteredFonts = (fonts || [])
            .filter((font): font is string => typeof font === "string" && font.trim() !== "")
            .map((font) => font.trim())
            .filter((font) => !ignoredFonts.includes(font));

        if (filteredFonts.length === 0) return;

        const formattedFonts = filteredFonts
            .map((font) => font.replace(/ /g, "+"))
            .join("&family=");

        const fontLink = document.createElement("link");
        fontLink.href = `https://fonts.googleapis.com/css2?family=${formattedFonts}:wght@400;700&display=swap`;
        fontLink.rel = "stylesheet";
        document.head.appendChild(fontLink);

        return () => {
            document.head.removeChild(fontLink);
        };
    }, [fonts]);
};
